import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';

export function useUpdateDisbursementSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { source_account_id: number }) => {
      const res = await authFetch(`${API_URL}/disbursement-settings/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error('Failed to update disbursement settings');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['disbursementSettings'] });
    },
  });
} 